import React, { useEffect, useState } from "react";
import siteLogo from "../../../assets/images/logo.png";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import useForm from "../../../hooks/useForm";
import { formValidate } from "../../../helpers/formValidate";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { sendOtp } from "../../../services/ProfileService";
import VerifyOtpForm from "./VerifyOtpForm";
import ChangePassword from "./ChangePassword";
import { useSelector } from "react-redux";
import adminbg from "../../../assets/images/adminbg.jpg";
import Image from "../../../components/elements/Image";

const validation = {
  email: { required: true, message: "Email is required" },
};

const ForgotPassword = () => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField } = useForm({}, validation);
  const navigate = useNavigate();
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState({
    color: "red-600",
    message: null,
  });
  const [loaded, setLoaded] = useState(true);
  const [isOtp, setIsOtp] = useState(true);
  const [email, setEmail] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [verifiedOtpData, setVerifiedOtpData] = useState();
  const [showResendButton, setShowResendButton] = useState(false);
  const [timer, setTimer] = useState(60);

  const otpSubmit = async (values) => {
    setLoaded(false);
    try {
      await sendOtp({
        requestType: "RESETPASSWORD",
        email: email,
      }).then((res) => {
        if (res?.status === 201) {
          toast.success("OTP Code Sent To Your Email Id.");
          setIsOtp(true);
          setEmail(email);
          setTimer(60);
          setShowResendButton(true);
        } else {
          toast.error(res?.data?.message);
        }
      });
      setLoaded(true);
    } catch (error) {
      setLoaded(true);
      setIsOtp(false);
      toast.error(error);
    }
  };

  useEffect(() => {
    let interval;
    if (showResendButton && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            clearInterval(interval);
            setShowResendButton(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showResendButton, timer]);

  useEffect(() => {
    if (isOtp) {
      setShowResendButton(true);
    }
  }, [isOtp, isVerified]);
  const settings = useSelector((state) => state?.settings?.data);

  // const cancelChange = () => {
  //   navigate(`/signin`);
  // };
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-denim to-mauve flex items-center justify-center py-6 px-6 relative z-0">
      <div className="absolute inset-0 z-[-1] opacity-50">
        <Image src={adminbg} alt={""} classes="object-cover" />
      </div>
      <div className="w-full max-w-md shadow-md relative z-10 rounded-xl bg-white py-6">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2 space-y-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm space-y-8">
            <div className="w-full h-12 flex">
              <Image src={settings?.favicon?.url || siteLogo} alt={""} classes="object-contain" />
            </div>
            {isOtp ? (
              <div className="space-y-1 text-center">
                <h2 className="text-lg font-bold text-denim">Change Password</h2>
                <h2 className="text-sm text-gray-500">Set new password for your account.</h2>
              </div>
            ) : (
              <div className="space-y-1 text-center">
                <h2 className="text-lg font-bold text-denim">Forgot Password</h2>
                <h2 className="text-sm text-gray-500">Enter Your Email To Reset Password</h2>
              </div>
            )}
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            {!isOtp && (
              <>
                <form onSubmit={(event) => handleSubmit(event, otpSubmit)}>
                  <div className="relative mb-4">
                    <Input
                      label={"Email"}
                      inputType={"text"}
                      inputPlaceholder={"Enter your email"}
                      value={values.email}
                      inputName={"email"}
                      onChange={(e) => {
                        handleChange(e);
                        setEmail(e.target.value);
                      }}
                      {...formValidate(errors, "email")}
                    />
                  </div>
                  <div className="relative">
                    <Button buttonClasses={"!w-full"} buttonHasLink={false} buttonType={"submit"} buttonLabel={"Send Code"} />
                  </div>
                  <div className="flex justify-end">
                    <Button
                      buttonClasses={"bg-transparent !text-slate-500 border-none hover:!text-slate-100 !w-full hover:!bg-transparent hover:!text-black !flex !item-baseline !gap-0.5"}
                      buttonHasLink={true}
                      buttonType={"button"}
                      buttonLabel={"Back to login"}
                      buttonIcon={"fa-regular fa-circle-arrow-left"}
                      buttonIconPosition={"left"}
                      buttonLink={location?.state === "admin" ? "/admin/signin" : "/signin"}
                    />
                  </div>
                </form>
              </>
            )}

            {/* {isOtp && !isVerified && (
              <>
                <VerifyOtpForm
                  email={email}
                  setEmail={setEmail}
                  isVerified={isVerified}
                  setIsVerified={setIsVerified}
                  isOtp={isOtp}
                  setIsOtp={setIsOtp}
                  verifiedOtpData={verifiedOtpData}
                  setVerifiedOtpData={setVerifiedOtpData}
                />
                <div className="mt-2">
                  <Button
                    buttonClasses={
                      "w-full text-white !bg-sky-700 focus-visible:outline  justify-center rounded-md"
                    }
                    buttonHasLink={false}
                    buttonType={"button"}
                    buttonLabel={"Resend Code"}
                    buttonFunction={onSubmit}
                    isDisable={showResendButton}
                  />
                </div>
                {showResendButton && (
                  <div className="text-center text-red-700 mt-2">
                    Resend Code in {timer} seconds
                  </div>
                )}
              </>
            )} */}

            {isOtp && (
              <>
                <ChangePassword email={email} setEmail={setEmail} showResendButton={showResendButton} timer={timer} otpSubmit={otpSubmit} location={location} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
